import { render, staticRenderFns } from "./DocumentContent.vue?vue&type=template&id=6d50b134&"
import script from "./DocumentContent.vue?vue&type=script&lang=js&"
export * from "./DocumentContent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentContent.vue?vue&type=style&index=0&id=6d50b134&prod&lang=scss&"
import style1 from "./DocumentContent.vue?vue&type=style&index=1&id=6d50b134&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports